import React from 'react'
import { string, arrayOf } from 'prop-types'
import styled from 'styled-components'

import ScrollSpyNav from 'components.v2/ScrollSpyNav'
import Text from 'components.v2/Text'

const Category = ({ categories }) => (
  <ScrollSpyNav
    list={categories}
    renderContainer={CategoryContainer}
    renderItem={CategoryItem}
  />
)

Category.propTypes = {
  categories: arrayOf(string),
}

export default Category

export const CategoryContainer = styled.div`
  position: relative;
  width: 160px;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
`

export const CategoryItem = styled(Text)`
  display: block;
  margin: 10px 0;
  border-right: 2px solid transparent;
  padding: 0 15px;
  text-align: right;

  &.active {
    border-right-color: ${props => props.theme.colors.orange};
    color: ${props => props.theme.colors.orange} !important;
  }
`
